export enum MdsThumbnailVisualType {
  Collage = 'collage',
  Table = 'table',
  Map = 'map',
  Kanban = 'kanban',
  Gantt = 'gantt',
  Charts = 'charts',
  Roles = 'roles',
  Files = 'files',
  Padlock = 'padlock',
}
